var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBillingIcon = function SvgBillingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.102 5.953h12.38v9.17h-12.38v-9.17Z",
    fill: "#F8CFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.54 18.453h33.943v7.38a2.829 2.829 0 0 1-2.828 2.829H3.367a2.829 2.829 0 0 1-2.829-2.829v-7.38Z",
    fill: "#0D66FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.756 6.582h8.1-8.1Zm0 0H1.29h8.467ZM17.357 1.688h15.37-15.37Zm0 0H1.29h16.068ZM9.756 10.54h8.1-8.1Zm0 0H1.29h8.467ZM9.756 14.496h8.1-8.1Zm0 0H1.29h8.467Z",
    stroke: "#2576FF",
    strokeWidth: 1.499,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgBillingIcon;